/**
 * Formats a clinician's full name from a person object.
 * Joins first, middle, and last name (skipping any that are absent or blank),
 * collapses any internal whitespace, and trims the result.
 *
 * @param {{ first_name?: string, middle_name?: string, last_name?: string } | null | undefined} person
 * @returns {string}
 */
export const formatClinicianName = (person) =>
  [person?.first_name, person?.middle_name, person?.last_name]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim();
